"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFigureSmallScreen = exports.renderChildren = exports.getDescription = exports.generatePagingOptions = exports.figureSmallScreen = exports.DEFAULT_PAGE_LIMITS = void 0;
var _react = require("react");
/**
 * Determine if we are working with a small screen.
 * 'small screen' in this case is relative to the width of the description div
 */
const figureSmallScreen = () => {
  const descriptionElement = document.getElementById("pagination-description");
  if (!descriptionElement) {
    return true;
  }
  return descriptionElement.getBoundingClientRect().width < 230;
};

/**
 * Iterate direct react child components and override the value of the prop specified by @param dataForwardProp
 * for those child components.
 * @param children - react node children to iterate
 * @param dataForwardProp - the name of the prop from the children components to override
 * @param data - actual data to be passed to the prop specified by @param dataForwardProp
 */
exports.figureSmallScreen = figureSmallScreen;
const renderChildren = (children, dataForwardProp, data) => {
  return _react.Children.map(children, child => {
    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      [dataForwardProp]: data
    });
  });
};
exports.renderChildren = renderChildren;
const DEFAULT_PAGE_LIMITS = exports.DEFAULT_PAGE_LIMITS = [50, 100, 200];
const generatePagingOptions = pageLimits => {
  return pageLimits.map(limit => ({
    value: limit,
    label: "".concat(limit, "/page")
  }));
};
exports.generatePagingOptions = generatePagingOptions;
const getDescription = _ref => {
  let {
    description,
    isSmallScreen,
    totalItems,
    itemName,
    visibleCount
  } = _ref;
  if (description) {
    return description;
  }
  if (isSmallScreen) {
    return "".concat(visibleCount, " out of ").concat(totalItems);
  }
  if (visibleCount === totalItems && visibleCount > 1) {
    return "Showing all ".concat(totalItems, " ").concat(itemName, "s");
  }
  return "Showing ".concat(visibleCount, " out of ").concat(totalItems, " ").concat(itemName).concat(totalItems !== 1 ? "s" : "");
};
exports.getDescription = getDescription;
const useFigureSmallScreen = () => {
  const [isSmallScreen, setSmallScreen] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const handleResize = () => {
      setSmallScreen(figureSmallScreen());
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return isSmallScreen;
};
exports.useFigureSmallScreen = useFigureSmallScreen;